import React, { useEffect } from "react";

import Dropdown from "components/Common/Dropdown/Dropdown";
import { NotificationIcon } from "components/Icons";
import { markAsReadNotification } from "api";
import "./Notification.scss";

const Notification = ({
	isNotificationOpen,
	setNotificationOpen,
	notifications,
	setNotifications,
	isNewNotification,
	setNewNotification,
}) => {
	const notificationIcon = (
		<div className="avatar-badge">
			<NotificationIcon isNew={isNewNotification} />
		</div>
	);

	useEffect(() => {
		setNewNotification(notifications?.length);
	}, [notifications]);

	const deleteState = (id) => {
		setNotifications((prevState) =>
			prevState.filter((notify) => notify?.id !== id)
		);
	};
	const markAsRead = async (notificationId) => {
		try {
			const { data } = await markAsReadNotification(notificationId);
			deleteState(data);
		} catch (error) {
			console.error("Failed to mark as read", error);
		}
	};
	const handleToggle = () => {
		setNotificationOpen((prev) => !prev);
		setNewNotification(false);
	};
	return (
		<Dropdown
			trigger={notificationIcon}
			isOpen={isNotificationOpen}
			onToggle={setNotificationOpen}
			customClass="notification-dropdown user-info"
		>
			<ul className="dropdown-list profile-dropdown">
				{notifications?.length ? (
					notifications.map((notification, i) => (
						<li
							key={i}
							className="dropdown-list-item"
							onClick={() => {
								markAsRead(notification?.id);
								setNotificationOpen(false);
							}}
						>
							<div className="dropdown-list-block profile-details d-flex align-items-center">
								{/* <span className="profile-details-img user-info dis-mr-8"></span> */}
								<div className="d-flex flex-column">
									<span className="plt-body-sm plt-font-color-primary">
										{notification?.data?.message}
									</span>
									{notification?.data?.url && (
										<span className="plt-body-xs plt-font-color-tertiary">
											<a href={`${notification?.data?.url}`}>open</a>
										</span>
									)}
								</div>
							</div>
						</li>
					))
				) : (
					<li className="dropdown-list-item">
						<div className="dropdown-list-block profile-details d-flex align-items-center">
							<div className="d-flex flex-column">
								<span className="plt-heading-xxs plt-font-color-primary">
									No notifications
								</span>
							</div>
						</div>
					</li>
				)}
			</ul>
		</Dropdown>
	);
};

export default Notification;
